import styled from "styled-components";

export const AppContainer = styled.div`
  width: calc(100% - 40px);
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 30px 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
`;
